import React from 'react';
import { formValidationCheckV2 } from "@/utils/validation/formValidation";
import { ActionMenu, colors2, UI_BODY_BOLD_SM_DF, UI_HEADLINE } from "oolib";
import { Fragment, useState } from "react";
import styled from 'styled-components';
import {
  allWidgetsBaseConfs,
  componentsMap,
  defaultWidgetConfigs,
  processRawConfig,
  TOTAL_COLUMNS,
  widgetMetaConfigs,
} from "../../CONFIG";
import { _getStartEndColumns } from "../../utils/_getStartEndColumns";
import { handleDeleteWidget } from "../../utils/handleDeleteWidget";
import { AddWidgetButton } from "../AddWidgetButton";



const someRequiredPropsUnset = (widgetConfig) => {
  const { failedBlocks } = formValidationCheckV2({
    blocks: widgetMetaConfigs[widgetConfig.comp],
    content: widgetConfig,
  });

  if (failedBlocks.length > 0) return true;
  //else
  return false;
};


const StyledHeader = styled.div`
  width: 100%;
  padding: 0.8rem 1.6rem;
  text-align: left;
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;



export const WidgetRenderer = ({
  widgetConfig: _widgetConfig,
  widgetIdx,
  underEditWidgetIdx,
  setUnderEditWidgetIdx,
  config,
  setConfig
}) => {

  /**
   * so the dataviz components expect props in the format of something like:
   * {
   *   contentType: String,
   *   rollupInjectProperty: { ... },
   *   dimensions: [x,y,z],
   * }
   * above is just an example, but such data structures basically.
   * Now it may not be possible for the Widget config form (which uses useOutOfTheBoxForm)
   * to prepare these configs in this exact format. 
   * 
   * Hence we need to do some preprocessing to get the required format
   */
const someReqPropsUnset = someRequiredPropsUnset(_widgetConfig)
  const widgetConfig = !someReqPropsUnset
    ? processRawConfig[_widgetConfig.comp] //basically if a processor function has been written for this component then use it to process and reshape the config. else do nothing
      ? processRawConfig[_widgetConfig.comp](_widgetConfig) 
      : _widgetConfig
    : _widgetConfig

  const { gridColumn, gridRow, props, comp } = widgetConfig;
  const defaultProps = defaultWidgetConfigs[comp]?.props || {} //these are pre defined via configs
  const Comp = componentsMap[comp];
  const [startCol, endCol] = _getStartEndColumns(gridColumn);
const [widgetTitle, setWidgetTitle] = useState(allWidgetsBaseConfs.find(c => c.comp === widgetConfig.comp)?.display)
  return (
    <div
      key={widgetConfig.id}
      style={{
        gridColumn,
        position: "relative",
        background: colors2.white,
        boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.06)",
        borderRadius: "4px",
        ...(widgetIdx === underEditWidgetIdx ? {border: `1px solid ${colors2.primary}`} : {})
      }}
    >
      {startCol === 1 && (
        <AddWidgetButton
          {...{
            currentFirstWidgetInRow: widgetConfig,
            widgetIndex: widgetIdx,
            config,
            setConfig,
            setUnderEditWidgetIdx,
            style: { height: "100%" },
          }}
        />
      )}
      <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
        <StyledHeader>
                  <div style={{ flex: "1 0 0" }}>
                    <UI_BODY_BOLD_SM_DF>
                      {widgetConfig?.props?.title || widgetTitle}
                    </UI_BODY_BOLD_SM_DF>
                  </div>
                  <ActionMenu actions={[
                {
                  display: "Edit",
                  value: "edit",
                  onClick: () => setUnderEditWidgetIdx(widgetIdx),
                },
                {
                  display: "Delete",
                  value: "delete",
                  onClick: () => {
                    handleDeleteWidget({
                        widgetIndex: widgetIdx,
                        config,
                        setConfig,
                        TOTAL_COLUMNS,
                      })
                  }
                    
                },
              ]} />
        </StyledHeader>
        
          {Comp ? (
            <Fragment>
              {someReqPropsUnset ? (
                <div
                  style={{
                    height: "100%",
                    background: colors2.grey5,
                    padding: '0 16px 10px 16px',
                    flexGrow: 1
                  }}
                >
                  <UI_HEADLINE style={{ color: colors2.grey50 }}>
                    {
                      allWidgetsBaseConfs.find((d) => d.comp === widgetConfig.comp)
                        ?.display
                    }
                  </UI_HEADLINE>
                </div>
              ) : (
                <div style={{padding: '0 16px 10px 16px'}}>
                <Comp
                  {...defaultProps}
                  {...props}
                  id={widgetConfig.id}
                  index={widgetIdx}
                  setWidgetTitle={setWidgetTitle}
                />
                </div>
              )}
            </Fragment>
          ) : (
            <div>invalid component</div>
          )}
        </div>
      </div>
  );
};
